import JobListNoSidebarContainer from "../../../components/job/listing/JobListNoSidebar";

const JobListNoSidebar = () => {
  return <JobListNoSidebarContainer />;
};

export default JobListNoSidebar;
